import { styled } from "@mui/material/styles";

import AnimatedLogo from "@common/AnimatedLogo";
import HomePage from "@common/home/HomePage";
import useShopContext from "@hooks/useShopContext";

import ProductsContainer from "@common/product/ProductsContainer";

const StyledDiv = styled("div")(() => ({
  flexGrow: 1,
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#fff",
  minHeight: "100vh",
}));

const Home = () => {
  const { shop } = useShopContext();

  if (!shop) {
    return (
      <StyledDiv>
        <AnimatedLogo style={{ maxWidth: "10%" }} />
      </StyledDiv>
    );
  }

  if (shop.use_welcome_page) {
    return <HomePage />;
  }

  return <ProductsContainer />;
};

export default Home;
